<template>

    <div id="footermerceddiv" >
        <div class="horizFlex">
            <!-- <img alt="school logo" :src="badgeIcon_footer"  class="logofooter" v-if="currentNav=='back'"> -->
            <div class="vertFlexLeft">
                <label class="foottext_frontmerced" v-if="currentNav=='front'">{{footLinkText_front}}</label>
                <label class="foottext_backmerced" v-if="currentNav=='back'">{{footLinkText_back}}</label>
            </div>
        </div>
        <div class="school footertextmerced" v-if="currentNav=='back'">
            <!-- <div class="vertFlex">
                <label class="infosmallmerced">{{badgeData.location.addressLine1}}, {{badgeData.location.city}} {{badgeData.location.stateCode}}  {{badgeData.location.postalCode}}</label>
                <label class="infosmallmerced">{{badgeData.location.phoneNumber | formatPhone}}</label>
            </div> -->
            
            <br>
            <label class="bold" >{{footerTextBack}}</label>
            
        </div>
        <div class="footdiv" v-if="currentNav=='front'">
            <label class="bold" v-if="badgeData.person.departmentName!=null">{{badgeData.person.departmentName}}</label>
           
        </div>
    </div>

</template>

<script>
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import {mapFields} from 'vuex-map-fields'
import badge from '../../services/badge.js'
import style from '../../style.js'
export default {
  components:{
      smallbutton,
      linkbutton
  },
  name:"footer_merced",
  mixins:[style, badge],
  props:{
       
  },
  data(){
      return{
          
      }
  },
  computed:{
    ...mapFields([
        'badgeData',
        'imageBasePath',
        'BadgeDesign',
    ]),

  },
  methods:{
      
  }
}
</script>

<style>
.footdiv{
 /* background-color:#00205c;  */
 /* background-color:#c38f00;  */
  /*background-color:#d5e5e8; */
  background-color: var(--footer-background-bar);
 margin:5px 0px 0px 0px;  
 padding:5px 0px 30px 0px;
 font-size:xx-large;
 /* color:white; */
 color:var(--footer-text-bar);
}
.infosetmerced{
    display:flex;
    flex-direction: column;
    margin:15px 0px 30px 0px;
}
.footertextmerced{
    
    margin:20px 50px 20px 50px;
}
.foottext_frontmerced{
    font-weight: bold;
    margin-left:10px;
    color:var(--footer-text-front)
}
.foottext_backmerced{
    font-weight: bold;
    font-size:smaller;
    margin-left:10px;
    color:var(--footer-text-back)
}
.infosmallmerced{
    font-size:small;
    color:var(--back-text-color);
}
</style>



